import { IDeletePgtoContratoFinanceiroUseCase } from "../../../presentation/useCases/delete/delete_pgto_contrato_financeiro_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeletePgtoContratoFinanceiroUseCase
 */

export class DeletePgtoContratoFinanceiroUseCase implements IDeletePgtoContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deletePgtoContratoFinanceiro(idPgto: number): Promise<void> {
    await this.repository.deletePgtoContratoFinanceiroById(idPgto);

  }
}
